
/**
 * Steps in the process of adding an organization
 */
export class OrganizationModalStep
{
	static START = 'start'
	static SEARCH = 'search'
	static SEARCH_RESULTS = 'search_results'
	static ADDED_ORG_TO_USER = 'added_org_to_user'

	static NO_ACTIVE_ORGS = "no_active_orgs"


	static CREATE = 'create'
	static CREATED = 'created'
	static FAILED = 'failed'
}
